import backend, {AGENTCORE_ENGINE_API, AGENTCORE_ENGINE_WS_API} from 'utils/backend/server/api_library';
import {getJwtToken} from 'utils/auth/getSession';

class AgentChatWebsocketManager {
  constructor({onInit, onChunk, onDone, onError, onClose} = {}) {
    this.ws = null;
    this.onInit = onInit;
    this.onChunk = onChunk;
    this.onDone = onDone;
    this.onError = onError;
    this.onClose = onClose;
  }

  async connect(message, sessionRn) {
    const token = await getJwtToken();
    const url = `${AGENTCORE_ENGINE_WS_API}?token=${encodeURIComponent(token)}`;
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      this.ws.send(JSON.stringify({action: 'sendMessage', message, sessionRn: sessionRn || undefined}));
    };

    this.ws.onmessage = (evt) => {
      let data;
      try {
        data = JSON.parse(evt.data);
      } catch {
        return;
      }
      if (data.type === 'init') this.onInit?.(data);
      else if (data.type === 'chunk') this.onChunk?.(data);
      else if (data.type === 'done') this.onDone?.(data);
      else if (data.type === 'error') this.onError?.(data);
    };

    this.ws.onerror = (event) => {
      console.error('WebSocket error:', event);
      this.onError?.({message: 'Connection error. Please try again.'});
    };

    this.ws.onclose = () => {
      this.onClose?.();
    };
  }

  close() {
    this.ws?.close();
  }
}

const sendMessage = (message, sessionRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat`;
  return backend.post(url, {message, sessionRn});
};

const listSessions = () => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat/sessions`;
  return backend.get(url);
};

const getSession = (sessionRn) => {
  const url = `${AGENTCORE_ENGINE_API}/agent/chat/${sessionRn}`;
  return backend.get(url);
};

export default {AgentChatWebsocketManager, sendMessage, listSessions, getSession};
